import { EventEmitter } from 'events';
import dispatcher from '../dispatcher.js';
import { API, Auth } from 'aws-amplify'
class ImageStore extends EventEmitter {
	constructor() {
		super();
		this.handleImages = this.handleImages.bind(this);
		this.receiveImages = this.receiveImages.bind(this);
		this.searchImage = this.searchImage.bind(this);
		this.pushNavigationHistory = this.pushNavigationHistory.bind(this);
		this.handleSearchPagination = this.handleSearchPagination.bind(this);

		this.itemsPerPage = 15;
		this.images = [];
		this.navigationHistory = [];
		this.hasBefore = false;
		this.hasNext = false;
		this.lastIndex = false;

		//Valori per la ricerca
		this.searchMode = false;
		this.currentPage = false;
		this.totalPages = false;

		//Filtri
		this.bucketFilter = [];
	}

	async receiveImages(useIndex) {
		try {
			const userSession = await Auth.currentSession();
			let params = {
				headers: {
					Authentication: userSession.idToken.jwtToken
				},
				queryStringParameters: {}
			}
			if(useIndex) {
				params.queryStringParameters.lastIndex = this.lastIndex;
			}
			return API.get('imageAPI', '', params);
		} catch (error) {
			console.error(error.message);
		}
	}

	async searchImage(options) {
		try {
			const userSession = await Auth.currentSession();
			let params = {
				headers: {
					Authentication: userSession.idToken.jwtToken
				},
				queryStringParameters: options
			}
			return API.get('imageAPI','search/', params);
		} catch(error) {
			console.error(error.message);
		}
	}

	handleSearchPagination(results) {
		this.hasBefore = results.offset > 0;
		this.images = results.images;
		this.hasNext = this.currentPage < results.pages;
		this.emit('change');
	}

	getImages() {
		return this.images;
	}

	getHasBefore() {
		return this.hasBefore;
	}

	getHasNext() {
		return this.hasNext;
	}

	getLastIndex() {
		return this.lastIndex;
	}

	getSearchMode() {
		return this.searchMode;
	}

	handleImages(response) {
		if(response.status) {
			this.images = response.images;
			if(response.lastIndex) {
				return response.lastIndex;
			}
			return false;
		}
	}

	pushNavigationHistory(newIndex) {
		let historyObject = {
			nextIndex: newIndex,
			currentIndex: this.lastIndex
		}
		if(this.navigationHistory.length) {
			historyObject.prevIndex = this.navigationHistory[this.navigationHistory.length - 1].currentIndex;
		} else {
			historyObject.prevIndex = false;
		}
		this.navigationHistory.push(historyObject);
		this.lastIndex = newIndex;
		this.hasBefore = this.navigationHistory.length > 1;
		this.hasNext = newIndex !== false;
	}

	handleActions(action) {
		switch(action.type) {
			case 'getImages':
			this.searchMode = false;
			let useIndex = false;
			if(action.direction && action.direction === 'fw') {
				useIndex = true;
				this.receiveImages(useIndex).then(this.handleImages)
				.then((lastIndex) => {
					this.pushNavigationHistory(lastIndex);
					this.emit('change');
				});
			} else if(action.direction && action.direction === 'bw') {
				let historyObjectRemoved = this.navigationHistory.pop();
				this.lastIndex = historyObjectRemoved.prevIndex;
				useIndex = true && this.lastIndex !== false;
				this.receiveImages(useIndex).then(this.handleImages)
				.then((lastIndex) => {
					this.lastIndex = lastIndex;
					this.hasBefore = this.navigationHistory.length > 1;
					this.hasNext = lastIndex !== false;
					this.emit('change');
				});
			} else {
				this.receiveImages(false).then(this.handleImages)
				.then((lastIndex) => {
					this.pushNavigationHistory(lastIndex);
					this.emit('change');
				});
			}
			break;
			case 'searchImage':
				this.searchMode = true;
				let options = {
					offset: 0,
				}
				if( action.searchValue ) {
					options.search = action.searchValue;
				}
				console.log(this);
				if( this.bucketFilter.length ) {
					console.log("bucketFilter qui");
					console.log(this.bucketFilter);
					options.bucketFilter = this.bucketFilter.join(';');
				}

				switch(action.direction) {
					case 'fw':
						this.currentPage++;
						options.offset = (this.currentPage - 1) * this.itemsPerPage;
						this.searchImage(options)
						.then(this.handleSearchPagination);
					break;
					case 'bw':
						this.currentPage--;
						options.offset = (this.currentPage - 1) * this.itemsPerPage;
						this.searchImage(options)
						.then(this.handleSearchPagination);
					break;
					default:
						this.currentPage = 1;
						this.searchImage(options)
						.then(this.handleSearchPagination);
					break;
				}
			break;
			case 'setFilter': 
				this.bucketFilter = action.bucketFilter;
			break;
			default:
			break;
		}
	}
}

const store = new ImageStore();
dispatcher.register(store.handleActions.bind(store));

export default store;


// WEBPACK FOOTER //
// ./src/stores/image-store.js